import { Suspense, lazy } from "react";

import { useVerificationWelcomeGate } from "../hooks/useVerificationWelcomeGate";

// The welcome carries its animation; only a member who is actually shown it downloads it.
const VerificationWelcomeDialog = lazy(() =>
  import("./VerificationWelcomeDialog").then((module) => ({ default: module.VerificationWelcomeDialog })),
);

/**
 * Mounted once by the dashboard shell: announces the organization's approval the first time a member is in
 * the dashboard after it. Renders nothing otherwise — internal staff, unverified organizations, approvals
 * older than the fresh window, the onboarding route (which shows the welcome inline) and a welcome already
 * seen.
 */
export function VerificationWelcomeGate() {
  const { open, purpose, dismiss } = useVerificationWelcomeGate();
  if (!open) return null;
  return (
    <Suspense fallback={null}>
      <VerificationWelcomeDialog open purpose={purpose} onClose={dismiss} />
    </Suspense>
  );
}
